/**
 * Format a date string into a localized date format.
 * @param {string} dateString - The date string to format.
 * @param {string} locale - The locale to use for formatting the date. eg. 'en-US', 'fr-FR'.
 * @return {string|null}
 */
const getLocalisedDateFromString = (dateString, locale) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export default getLocalisedDateFromString;
